import { render, staticRenderFns } from "./CalculateResultDialog.vue?vue&type=template&id=0485cc7f"
import script from "./CalculateResultDialog.vue?vue&type=script&lang=js"
export * from "./CalculateResultDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports